import { Typography } from 'components/DesignSystemV2/Typography';
import React from 'react';
import { colorsV2 } from 'style/colors-v2';
import styled from 'styled-components';
import LinearThinkReviewsList from './LinearThinkReviewsList';

import { graphql, useStaticQuery } from 'gatsby';
import { get } from 'lodash';
import { toScreen } from 'utils/media-query/responsive.util';
import { SectionV3 } from 'components/SectionV3';
import { ResponsiveContainer } from 'components/ResponsiveContainer';

const Wrapper = styled.div`
  display: grid;
  gap: 48px;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${toScreen(775)} {
    flex-direction: column;
    gap: 24px;
    align-items: center;
    text-align: center;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 65%;

  ${toScreen(775)} {
    max-width: 100%;
  }
`;

const RightSection = styled.div`
  display: grid;
  gap: 8px;
`;

const studentOnlineCourseFacebookReviewsQuery = graphql`
  query allGoogleSpreadsheetDolLandingPageStudentReviews {
    allGoogleSpreadsheetDolLandingPageReviewAllNew(
      filter: { listing: { eq: "listed" } }
      sort: { fields: order, order: ASC }
    ) {
      edges {
        node {
          id
          reviewLink
          avatarLink
          coverLink
          fullName
          reviewDate
          reviewContent
          listing
          program
          order
        }
      }
    }
  }
`;

const LinearThinkingReviews = ({ title, subtitle, reviewsCount }) => {
  const data = useStaticQuery(studentOnlineCourseFacebookReviewsQuery);
  // Filter out reviews that do not have an avatar or review content
  const reviews =
    data.allGoogleSpreadsheetDolLandingPageReviewAllNew.edges.filter(item => {
      const isNotBlank =
        (get(item, 'node.reviewContent', '') || '').trim().length > 0;
      return item.node.avatarLink && isNotBlank;
    });

  return (
    <SectionV3>
      <ResponsiveContainer>
        <Wrapper>
          <HeaderWrapper>
            <LeftSection>
              <Typography
                variant="bold/24-32"
                tabletVariant="bold/32-40"
                desktopVariant="bold/40-48"
                color={colorsV2.black100}
                v3
              >
                {title}
              </Typography>
            </LeftSection>
            <RightSection>
              <Typography variant="regular/28-36" color={colorsV2.neutral200}>
                {reviewsCount} đánh giá
              </Typography>
              <Typography variant="regular/16-24" color={colorsV2.neutral180}>
                {subtitle}
              </Typography>
            </RightSection>
          </HeaderWrapper>
          <LinearThinkReviewsList reviews={reviews} />
        </Wrapper>
      </ResponsiveContainer>
    </SectionV3>
  );
};

export default LinearThinkingReviews;
